import * as React from "react";
import { Helmet } from "react-helmet-async";
import { Flex } from "@chakra-ui/react";

interface SideNavLayoutProps {
  pageTitle?: string;
}

export const SideNavLayout: React.FC<SideNavLayoutProps> = ({
  pageTitle = "Publisher",
  children,
}) => {
  return (
    <Flex flexDirection={"column"} h={"100vh"} w={"100%"}>
      <Helmet titleTemplate={"%s | illuma UI"}>
        <title>{pageTitle}</title>
      </Helmet>
      <Flex flexDirection={"row"} h={"100vh"} w={"100%"}>
        {children}
      </Flex>
    </Flex>
  );
};
